import { Component } from '@angular/core';

@Component({
    selector: 'page-with-splash',
    imports: [],
    templateUrl: './page-with-splash.component.html',
    styleUrl: './page-with-splash.component.scss'
})
export class PageWithSplashComponent {

}
